import { render, staticRenderFns } from "./LeilaoCardLoader.vue?vue&type=template&id=31f1f4d9"
import script from "./LeilaoCardLoader.vue?vue&type=script&lang=js"
export * from "./LeilaoCardLoader.vue?vue&type=script&lang=js"
import style0 from "./LeilaoCardLoader.vue?vue&type=style&index=0&id=31f1f4d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports